import {Vacation} from '../vacation';

export function toString(this: Vacation) {
    return `Vacation start: ${this.start}`;
}
